import React, { useCallback, useMemo, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';
import qs from 'query-string';

import { NotificationManager } from '@atlas/core';
import { Button, DefaultPopup, Icon, Input } from '@atlas/ui';

import { urlSeparator } from 'common/constants';
import PaymentListItem from 'src/components/ClientProfile/Payment/PaymentListItem';

const SpeiDepositPopup = ({ data = {}, id }) => {
  const { url } = useRouteMatch();
  const backUrlArray = url.split(urlSeparator);
  backUrlArray.pop();
  const { paymentMethod, redirectUrl } = data;
  const { amount, clabe } = qs.parse(redirectUrl);
  const [userClabe, setUserClabe] = useState(clabe);
  const [isActiveInput, setIsActiveInput] = useState(false);
  const amountValue = useMemo(
    () => parseInt(typeof amount === 'string' ? amount : amount[0]),
    [amount],
  );

  const copyToClipboard = async text => {
    await navigator.clipboard.writeText(text);
    NotificationManager.notify({
      message: 'copied_data',
      status: 'success',
      type: 'notification',
    });
  };

  const handleClose = useCallback(() => {
    NotificationManager.removeNotification(id);
  }, [id]);

  return (
    <DefaultPopup
      className="spei-modal"
      headerTitle="deposit"
      headerTitlePosition="left"
      onClose={handleClose}
    >
      <div className="popup-content">
        <div className="popup-payment-method">
          <PaymentListItem amount={amountValue} payment={paymentMethod} showAmount />
        </div>
        <div className="popup-input-container">
          <Input
            active={isActiveInput === 'deposit_clabe'}
            className="popup-input"
            label="deposit_clabe"
            onBlur={() => setIsActiveInput(false)}
            onChange={e => setUserClabe(e.target.value)}
            onFocus={() => setIsActiveInput('deposit_clabe')}
            value={userClabe}
          />
          <div className="popup-input-button" onClick={() => copyToClipboard(userClabe)}>
            <Icon name="copy" />
          </div>
        </div>
      </div>

      <div className="popup__footer">
        <Button className="primary big block" label="ok" onClick={handleClose} />
      </div>
    </DefaultPopup>
  );
};

SpeiDepositPopup.propTypes = {
  data: PropTypes.object,
};

export default SpeiDepositPopup;
